module.exports = __webpack_public_path__ + "static/media/1.0f37de35.JPG";